import { render, staticRenderFns } from "./LeaguesManager.vue?vue&type=template&id=a58c4352&"
import script from "./LeaguesManager.vue?vue&type=script&lang=js&"
export * from "./LeaguesManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports